import { getAdapter, MessageComposeAdapter } from 'owa-addins-adapters';
import { ApiErrorCode } from '../ApiErrorCode';
import type { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult, createSuccessResult } from '../ApiMethodResponseCreator';
import { returnErrorIfUserCannotEditItem } from '../sharedProperties/itemPermissions';
import { convertIdsToTargetFormat, ConvertIdSource } from 'owa-immutable-id';
import { getUserMailboxInfo } from 'owa-client-ids';
import { isFeatureEnabled } from 'owa-feature-flags';
import { ConvertableIdFormat } from 'owa-immutable-id-store';

export default function saveAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: any,
    callback: ApiMethodCallback
) {
    const adapter: MessageComposeAdapter = getAdapter(hostItemIndex) as MessageComposeAdapter;

    if (returnErrorIfUserCannotEditItem(adapter, callback)) {
        return;
    }

    adapter.saveItem().then(async itemId => {
        if (!itemId) {
            callback(createErrorResult(ApiErrorCode.SaveError));
            return;
        }
        callback(
            createSuccessResult(
                isFeatureEnabled('fwk-immutable-ids')
                    ? (
                          await convertIdsToTargetFormat(
                              [itemId],
                              ConvertableIdFormat.EwsId,
                              getUserMailboxInfo().userIdentity,
                              ConvertIdSource.Addins
                          )
                      )?.[0]
                    : itemId
            )
        );
    });
}
